import { fetchToken } from "../../common/FetchCookie";
import { ADMIN, ADMIN_NOTIFICATIONS, BASE_URL, USERS as USERS_URL, USER_SEARCH } from "../../common/URLs";

// Ensure URLs are imported correctly or defined
const API_BASE_URL = `${BASE_URL}/${ADMIN}/${ADMIN_NOTIFICATIONS}`;
const USERS = `${BASE_URL}/${ADMIN}/${USER_SEARCH}`;

export const fetchAdminNotifications = async (page = 1) => {
  // Append page query parameter
  const url = `${API_BASE_URL}?page=${page}`;
  try {
    const token = await fetchToken();

    const response = await fetch(url, {
      method: "GET",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    // console.log("response", response)
    const data = await response.json();
    return data;
  } catch (error) {
    console.log("error", error);
    throw error;
  }
};

export const addNotifications = async (formData) => {
  const url = `${API_BASE_URL}`;
  try {
    const token = await fetchToken();

    // NOTE: When sending FormData, do NOT set Content-Type to application/json
    // The browser will automatically set Content-Type to multipart/form-data with the correct boundary
    const response = await fetch(url, {
      method: "POST",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: formData, // Send formData directly
    });

    const data = await response.json();
    return data;
  } catch (error) {
    console.log("error", error);
    throw error;
  }
};

export const fetchUsers = async (keyword, user_type) => {
  const url = `${USERS}?user_type=${user_type}&keyword=${keyword}`;
  try {
    const token = await fetchToken();
    const response = await fetch(url, {
      method: "GET",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const data = await response.json();
    return data;
  } catch (error) {
    console.log("error", error);
    throw error; // It's better to throw so the Thunk catches it
  }
};